import React from "react";

export default function About() {
    return (
        <section id="about">
            <div class="aboutContainer">
                <h1>Fernando Pulido</h1>
                <h2>A Bit of Everything</h2>
                <div class="aboutDescription">
                    <img src="/portrait.JPG"/>
                    <p>
                        Hello world! This page is currently undergoing major changes and redesigns. Please stay tuned. 2026.
                    </p>
                </div>
            </div>
        </section>
    );
}


// WEBPACK FOOTER //
// ./src/components/About.js